import React, { useEffect, useState } from 'react';
import { CardContent, Card, Grid, Typography, Box, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import SalesSteps from 'src/mics/components/affiliate/salesSteps/SalesSteps';
import SalesStepsMobile from 'src/mics/components/affiliate/salesSteps/SalesStepsMobile';
import AffiliateButton from 'src/mics/components/affiliate/AffiliateButton';
import CommisionDetails from 'src/mics/components/affiliate/CommisionDetails';
import AffiliateQuality from 'src/mics/components/affiliate/AffiliateQuality';
import FAQ from 'src/mics/components/FAQ';
import { detectAgent } from 'core/utils';
import withQuillLayout from 'src/_common/hoc/QuillLayout';
import supportTrack from 'src/support/handlers/track';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '16px',
  },
  affiliateDescription: {
    marginTop: '0.3em',
    padding: '0 22%',
  },
  affiliateDescriptionNoPad: {
    marginTop: '0.3em',
  },
  textCenter: {
    textAlign: 'center',
  },
  affiliateButton: {
    fontSize: '16px',
    borderRadius: '100px',
    fontWeight: 700,
    display: 'inline-block',
    minWidth: '200px',
  },
  affiliateTable: {
    width: '100%',
    padding: '7px 0 0 5px',
    borderCollapse: 'collapse',
    zIndex: 2,
  },
  affiliateTableHeader: {
    fontWeight: 400,
    border: 'none',
  },
  commissionbox: {
    border: '0px',
    padding: '40px 42px 50px',
    marginBottom: '110px',
    marginTop: '70px',
    borderRadius: '30px',
    '@media only screen and (max-width: 676px)': {
      padding: '40px 9px 29px',
      margin: '70px auto 75px',
    },
  },
  commissionDetailHeading: {
    textAlign: 'center',
    '@media only screen and (max-width: 960px)': {
      paddingBottom: '20px',
    },
    '@media only screen and (min-width: 961px)': {
      'padding-bottom': '40px',
    },
  },
  commissionTableWrapper: {
    border: '0px',
    borderRadius: '8px',
    overflow: 'hidden',

    '@media only screen and (max-width: 960px)': {
      marginBottom: '10px',
    },
    '@media only screen and (min-width: 961px)': {
      marginRight: '10px',
    },
    '@media only screen and (max-width: 410px)': {
      width: '100%',
    },
  },
  affiliateTableHeaders: {
    padding: '1em 0.7em',
    '&:not(:last-child)': {
      borderRight: '1px solid #DCDCDC',
    },
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    backgroundColor: '#EDFFF0',
    '@media only screen and (max-width: 600px)': {
      'font-size': '1rem',
    },
    // borderLeft: '8px solid',
    // '&:nth-child(1)': {
    //   borderRight: '4px solid',
    //   borderRightColor: theme.palette.grey[50],
    // },
    // '&:nth-child(2)': {
    //   borderLeft: '4px solid',
    //   borderLeftColor: theme.palette.grey[50],
    // },
  },
  affiliateTableData: {
    borderTop: '1px solid #DCDCDC',
    '&:not(:last-child)': {
      borderRight: '1px solid #DCDCDC',
    },
    padding: '22px 0px',
    fontSize: '18px',
    textAlign: 'center',
    background: theme.specialColors.CHECKOUT_PAGE_BG,
    fontWeight: 'bold',
    '@media only screen and (max-width: 767px)': {
      fontSize: '18px',
    },
    // borderLeft: '8px solid',
    // '&:nth-child(1)': {
    //   borderRight: '4px solid',
    //   fontWeight: '500',
    //   borderRightColor: theme.palette.grey[50],
    // },
    // '&:nth-child(2)': {
    //   borderLeft: '4px solid',
    //   borderLeftColor: theme.palette.grey[50],
    // },
  },
  font21: {
    fontSize: '1.1rem',
  },
  font24: {
    fontSize: '1.2rem',
  },
  font26: {
    fontSize: '1.6rem',
  },
  font20: {
    fontSize: '1.25rem',
  },
  font35: {
    fontSize: '2rem',
  },
  featureWrapper: {
    height: '100%',
    minHeight: '253px',
    backgroundColor: theme.specialColors.CHECKOUT_PAGE_BG,
    borderRadius: '8px',
    padding: '29px 30px',
    '@media only screen and (max-width: 960px)': {
      marginTop: '10px',
    },
    '@media only screen and (min-width: 961px)': {
      marginLeft: '10px',
    },
    '@media only screen and (max-width: 767px)': {
      padding: '29px 15px',
    },
  },

  titleContent: {},

  featureHeader: {
    fontWeight: 600,
    fontSize: '23px',
    float: 'left',
    padding: '0px 0px',
    margin: '0px 10px 19px 10px',
  },
  featureList: {
    clear: 'both',
    fontSize: '19px',
    fontWeight: 300,
    marginStart: '0px',
    padding: '0px 0 13px 0px',
    textAlign: 'left',
    'listStyle-position': 'inside',
    textIndent: '-1.4em',
  },
  affiliateQualityWrapper: {
    backgroundColor: theme.palette.grey[300],
    paddingTop: '25px',
    paddingBottom: '30px',
  },
  Commissiontitle: {
    fontSize: '2.2rem',
    fontWeight: 300,
  },
  faqholder: {
    marginBottom: '40px',
  },

  faqboxholder: {
    '@media screen and (max-width: 767px)': {
      'margin-top': '45px',
      textAlign: 'center',
    },
  },

  affiliateboxs: {
    'margin-top': '20px',
    '@media screen and (max-width: 767px)': {
      'margin-bottom': '20px',
      'margin-top': '10px',
    },
  },

  faqBox: {
    marginTop: '30px',
    '@media only screen and (max-width: 600px)': {
      textAlign: 'center',
      marginTop: '45px',
    },
  },
  expPanel: {
    border: '1px solid',
    borderWidth: '1px 0px',
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.grey[800],
    boxShadow: 'none',
    marginBottom: '0px !important',
    // paddingBottom: '16px',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 0,
    },
  },
  expDetail: {
    paddingLeft: '8px',
    paddingBottom: '32px',
    fontSize: '16px',
  },
  expanded: {
    color: theme.palette.primary.main,
    // backgroundColor: '#ffffff',
  },
  heading: {
    fontWeight: 600,
  },
}));

function Affiliate() {
  const classes = useStyles();

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(!!detectAgent().isMobile);
    // Track.visitedPage('affiliate')
  }, []);

  return (
    <>
      <div className="container">
        <Grid container justifyContent="center">
          <Grid item sm={12}>
            <h1 className="pageTitle">Earn Big Through Affiliate Sales</h1>
          </Grid>
        </Grid>

        <Box mx={isMobile ? 0 : 7}>
          <Grid container justifyContent="center">
            {isMobile ? <SalesStepsMobile classes={classes} /> : <SalesSteps classes={classes} />}
          </Grid>
        </Box>

        <Box mx={isMobile ? -5 : 7} boxShadow={3} className={classes.commissionbox}>
          <Card style={{ border: '0px', boxShadow: 'none', padding: '0px' }}>
            <CardContent
              style={{
                border: '0px',
                boxShadow: 'none',
                padding: '0px',
                margin: '0px 0px',
              }}
            >
              <Grid container justifyContent="center" style={{ marginBottom: '40px' }}>
                <Grid item sm={12} className={classes.commissionDetailHeading}>
                  <Typography variant="h4" className={classes.Commissiontitle}>
                    Commission Details
                  </Typography>
                </Grid>
                <CommisionDetails classes={classes} />
              </Grid>

              <AffiliateButton classes={classes} />
            </CardContent>
          </Card>
        </Box>
      </div>

      <AffiliateQuality classes={classes} />

      <div className="container">
        <Box mt={7} p={0}>
          <Grid item sm={12}>
            <Typography variant="h4" className={classes.font35} align="center">
              Frequently Asked Questions
            </Typography>
          </Grid>
        </Box>

        <FAQ classes={classes} />
      </div>
    </>
  );
}

export default withQuillLayout({
  children: Affiliate,
});
